import HTTP from './HTTP.js';
import SymfonyErrorFormatter from './SymfonyErrorFormatter';

class CampaignServices {
  static exportAll(filters = null, orderBy = null) {
    return HTTP.get(`campaigns/reports/export/all`, {
      responseType: 'blob',
      params: {
        orderBy: orderBy,
        filters: filters,
        include: 'agency',
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(() => {
        return Promise.reject('Could not get End Point');
      });
  }

  static exportToPDF(campaignId) {
    return HTTP.get(`campaigns/reports/export/${campaignId}`, {
      responseType: 'blob',
    })
      .then((response) => {
        return response.data;
      })
      .catch(() => {
        return Promise.reject('Could not get End Point');
      });
  }

  static getStatuses() {
    return HTTP.get(`campaigns/statuses`, {})
      .then((response) => {
        return {
          data: response.data,
          meta: response.data.meta,
        };
      })
      .catch(() => {
        return Promise.reject('Could not get End Point');
      });
  }

  static getCampaigns(status, include) {
    return HTTP.get(`campaigns`, {
      params: {
        status: status,
        include: include,
      },
    })
      .then((response) => {
        return {
          data: response.data.campaigns,
          meta: response.data.meta,
        };
      })
      .catch(() => {
        return Promise.reject('Could not get End Point');
      });
  }

  static getCampaignsByAgency(agency, include) {
    return HTTP.get(`campaigns/by-agency`, {
      params: {
        agency: agency,
        include: include,
      },
    })
      .then((response) => {
        return {
          data: response.data.campaigns,
          meta: response.data.meta,
        };
      })
      .catch(() => {
        return Promise.reject('Could not get End Point');
      });
  }

  static getCampaign(campaignId, include) {
    return HTTP.get(`campaigns/${campaignId}`, {
      params: {
        include: include,
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(() => {
        return Promise.reject('Could not get End Point');
      });
  }

  static getCampaignPublic(campaignId, token, include) {
    return HTTP.get(`campaigns/${campaignId}/public/${token}`, {
      params: {
        include: include,
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(() => {
        return Promise.reject('Could not get End Point');
      });
  }

  static getStats(campaignId, include) {
    return HTTP.get(`campaigns/${campaignId}/stats`, {
      params: {
        include: include,
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(() => {
        return Promise.reject('Could not get End Point');
      });
  }

  static createCampaign(campaign) {
    return HTTP.post(`campaigns`, campaign)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return SymfonyErrorFormatter.clean(error.response);
      });
  }

  static updateMediaCampaign(campaignId, formData) {
    return HTTP.post(`campaigns/${campaignId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return SymfonyErrorFormatter.clean(error.response);
      });
  }

  static uploadVideoViaUrl(campaignId, videoUrl) {
    return HTTP.post(`campaigns/${campaignId}/url-media`, {
      url: videoUrl,
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return SymfonyErrorFormatter.clean(error.response);
      });
  }

  static updateCampaignNote(campaignId, payload) {
    return HTTP.post(`campaigns/${campaignId}/add-note`, payload)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return SymfonyErrorFormatter.clean(error.response);
      });
  }

  static updateCampaignFoc(campaignId, foc) {
    const data = {
      statusLabel: foc,
    };
    console.log(data, campaignId);
    return HTTP.post(`campaigns/${campaignId}/update-status-label`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return SymfonyErrorFormatter.clean(error.response);
      });
  }

  static addCampaignAdjustments(campaignId, payload) {
    return HTTP.post(`campaigns/${campaignId}/adjustments`, payload)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return SymfonyErrorFormatter.clean(error.response);
      });
  }

  static manuallyCallSignifi(campaignId, callType) {
    return HTTP.post(`campaigns/${campaignId}/manually-call-signifi`, {
      type: callType,
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return SymfonyErrorFormatter.clean(error.response);
      });
  }

  static getSignifiProductResponse(campaignId) {
    return HTTP.get(`campaigns/${campaignId}/product`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return SymfonyErrorFormatter.clean(error.response);
      });
  }
}

export default CampaignServices;
